import React, { PropTypes } from 'react';
import { GoogleMapLoader, GoogleMap, Marker, Polyline, InfoWindow } from 'react-google-maps';
import MapStyles from './mapStyles.json';

class ItineraryMap extends React.Component {
    render () {
        var itinerary = this.props.itinerary,
            markers = [],
            polylinePath = [];

        itinerary.items
            .filter((day) => {
                return day && day.destinations && day.destinations.length;
            })
            .reduce((prev, curr) => {
                curr.destinations.forEach((destination) => {
                    if (!destination.id) {
                        return;
                    }

                    if (!prev.length || prev[prev.length - 1].id !== destination.id) {
                        prev.push(destination);
                    }
                });

                return prev;
            }, [])
            .forEach((destination, index) => {
                markers.push(
                    <Marker
                        key={ index }
                        position={ destination.location }
                        title={ destination.name }
                        defaultAnimation={ 2 }>
                    </Marker>
                );

                polylinePath.push(destination.location);
            });

        return (
            <div className="gmap-container">
                <GoogleMapLoader 
                    containerElement={
                        <div className="gmap" />
                    }

                    googleMapElement= {
                        <GoogleMap
                            defaultZoom={ 3 }
                            defaultCenter={ { lat: 21.306944, lng: -157.858333 } }
                            defaultOptions={ {
                                styles: MapStyles,
                            } }>
                            <Polyline
                                geodesic
                                options={ {
                                    strokeColor: '#FF0000',
                                    strokeOpacity: 1,
                                    strokeWeight: 2
                                } }
                                path={ polylinePath } />
                            { markers }
                        </GoogleMap>
                    }
                />
            </div>
        );
    }
};

export default ItineraryMap;


// WEBPACK FOOTER //
// ./src/app/components/googleMap/itineraryMap.jsx